import React from 'react';
import { EyeIcon, LinkIcon, MoreDotIcon, PencilIcon } from '../../assets/Icons';
import useMaterialActions from '../card/useMaterialActions';

// One row of the materials table. Reuses the shared material actions so its
// view/edit/copy/duplicate/delete behavior matches the grid card exactly.
const MaterialRow = ({ item, companySlug, baseUrl, setUpdatedData }) => {
  const { name, status, opens, completions, unique_visits } = item;
  const a = useMaterialActions({ item, baseUrl, companySlug, setUpdatedData });
  const statusClass = String(status || '').toLowerCase();

  return (
    <tr className="mt-row">
      <td className="mt-name">{name}</td>
      <td>
        <span className={`mt-pill ${statusClass}`}><i></i>{status}</span>
      </td>
      <td className="mt-r">{opens ?? 0}</td>
      <td className="mt-r">{completions ?? 0}</td>
      <td className="mt-r">{unique_visits ?? 0}</td>
      <td className="mt-actions-cell">
        <div className="mt-actions">
          <span onClick={a.navPublishedView} title="View"><EyeIcon /></span>
          <span onClick={a.navEditView} title="Edit"><PencilIcon /></span>
          <span onClick={a.handleLinkCopy} title="Copy link"><LinkIcon /></span>
          <span onClick={a.toggleMenu} title="More"><MoreDotIcon /></span>
          {a.copyVisible && <span className="mt-copied">Copied!</span>}
          {a.menuVisible && (
            <div className="mt-menu" ref={a.menuRef}>
              <a href="#view" onClick={a.navPublishedView}>View the material</a>
              <a href="#edit" onClick={a.navEditView}>Edit the material</a>
              <a href="#publish">Publish the material</a>
              <a href="#copy-url" onClick={a.handleLinkCopy}>Copy URL</a>
              <a href="#copy-embed" onClick={() => a.handleLinkCopy({ iframe: true })}>Copy embed code</a>
              <a href="#duplicate" onClick={a.handleDuplicate}>Duplicate the content</a>
              <a href="#delete" onClick={a.handleDelete}>Delete the content</a>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default MaterialRow;
